import o from "./index944.js";
import r from "./index820.js";
var p = o(r, "Map");
export {
  p as default
};
